<h1 class="page-title">Credential Verification Purchase</h1>
<p>
    Please be aware that when selecting the State Licensure Agency option, the credential verification letter will be sent by email to the agency selected.
</p>

<p
    *ngIf="isExpired()"
    style="color: red;"
>
    <strong>
        Your credential(s) will be listed as expired. Are you sure you want to continue?
    </strong>
</p>

<div *ngIf="(invalidCRTDate() | async)">
    The date of your credential is incomplete in our records. Please contact our office at 913.895.4900 or nbrc-info@NBRC.org to provide the approximate date you earned the credential so we may update your record. Include your current name and any previous name(s) when you contact our office.
</div>

<form
    *ngIf="(invalidCRTDate() | async) === false"
    [formGroup]="credentialVerificationForm"
    (ngSubmit)="onSubmit(credentialVerificationForm.value)"
>
    <fieldset class="field-group">
        <legend class="label field-group__label">Send To:</legend>
        <ul class="field-list">
            <li class="field field--inline field-list__item">
                <input
                    class="input input--radio"
                    id="send-to-state-licensure"
                    formControlName="sendTo"
                    name="sendTo"
                    type="radio"
                    [value]="sendToOptions.StateAgency"
                >
                <label
                    for="send-to-state-licensure"
                    class="label label--inline"
                >
                    State Licensure Agency
                </label>
            </li>

            <!-- Option to send to email -->
            <li class="field field--inline field-list__item">
                <input
                    class="input input--radio"
                    id="send-to-email"
                    formControlName="sendTo"
                    name="sendTo"
                    type="radio"
                    [value]="sendToOptions.Email"
                >
                <label
                    for="send-to-email"
                    class="label label--inline"
                >
                    Email
                </label>
            </li>
        </ul>
    </fieldset>

    <div class="form-actions form-actions--multi-step">
        <input
            type="submit"
            class="button form-actions__item form-actions__item--continue"
            value="Continue"
        >
    </div>
</form>
